import React from "react";
import "../pages/GramsevakPage.css";

const GramsevakPage = () => {
  const gramPanchayat = {
    name: ":- गट ग्रामपंचायत लोणारा /चक्कीखपा ",
    taluka: "नागपूर",
    district: "नागपूर",
    pincode: "441501",
    area: "-- हेक्टर",
    contact: "७८८७४५३९४३",
    email: "lonara.panchayat@maharashtra.gov.in",
    website: "gplonara.in",
  };

  const gramsevak = {
    name: "श्री.अमित बडोले ",
    designation: "ग्रामपंचायत अधिकारी",
    currentPosting: ":- गट ग्रामपंचायत लोणारा /चक्कीखपा ",
    photo: `${process.env.PUBLIC_URL}/images/sachiv.jpeg`,
  };

  const logo = `${process.env.PUBLIC_URL}/images/mh_logo.png`;
  const gpLogo = `${process.env.PUBLIC_URL}/images/gplogo.jpeg`;

  return (
    <div style={styles.container}>

      {/* ===== सरकारी हेडर ===== */}
      <header style={styles.govHeader}>
        <img src={logo} alt="Maharashtra Logo" style={styles.emblemImg} />
        <div style={styles.govTitle}>
          <h1 style={styles.govName}>महाराष्ट्र शासन</h1>
          <h2 style={styles.dept}>ग्रामविकास विभाग | जिल्हा परिषद नागपूर</h2>
        </div>
      </header>

      {/* ===== मुख्य हेडर ===== */}
      <header style={styles.mainHeader}>
        <img src={gpLogo} alt="Gram Panchayat Logo" style={styles.gpLogo} />
        <div style={styles.title}>
          <h1 style={styles.gpName}>{gramPanchayat.name}</h1>
          <p style={styles.gpInfo}>
            तालुका: {gramPanchayat.taluka} | जिल्हा: {gramPanchayat.district} | पिनकोड:{" "}
            {gramPanchayat.pincode}
          </p>
        </div>
      </header>

      {/* ======= ग्रा.वि.अ. वैयक्तिक माहिती (HEADER च्या खाली आणले) ======= */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>ग्रा.वि.अ. वैयक्तिक माहिती</h2>

        <div style={styles.infoGrid}>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>नाव</span>
            <span style={styles.infoValue}>{gramsevak.name}</span>
          </div>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>पद</span>
            <span style={styles.infoValue}>{gramsevak.designation}</span>
          </div>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>सध्याची पोस्टिंग</span>
            <span style={styles.infoValue}>{gramsevak.currentPosting}</span>
          </div>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>फोटो</span>
            <img src={gramsevak.photo} alt="Gramsevak" style={styles.gramsevakPhoto} />
          </div>
        </div>
      </section>

      {/* ===== ग्रामपंचायत माहिती ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>ग्रामपंचायत माहिती</h2>

        <div style={styles.infoGrid}>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>क्षेत्रफळ</span>
            <span style={styles.infoValue}>{gramPanchayat.area}</span>
          </div>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>संपर्क</span>
            <span style={styles.infoValue}>{gramPanchayat.contact}</span>
          </div>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>ई-मेल</span>
            <span style={styles.infoValue}>{gramPanchayat.email}</span>
          </div>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>वेबसाइट</span>
            <a
              href={`https://${gramPanchayat.website}`}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              {gramPanchayat.website}
            </a>
          </div>
        </div>
      </section>

      {/* ===== जबाबदाऱ्या / माहिती ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>मुख्य कर्तव्ये</h2>
        <ul style={styles.dutyList}>
          <li>ग्रामसभेचे आयोजन व कार्यवृत्त तयार करणे</li>
          <li>कर वसुली, पाणीपट्टी, स्वच्छता शुल्क</li>
          <li>मनरेगा, स्वच्छ भारत, PMAY योजनांची अंमलबजावणी</li>
          <li>जन्म-मृत्यू, लग्न नोंदणी</li>
          <li>ग्रामपंचायत अभिलेख (नमुना १ ते ३३) ठेवणे</li>
        </ul>
      </section>

      {/* ===== Footer ===== */}
      <footer style={styles.footer}>
        <div style={styles.footerLine}></div>
        <p style={styles.footerText}>
          ही सेवा पुस्तिका <strong>महाराष्ट्र नागरी सेवा (सेवा पुस्तिका) नियम १९८१</strong> नुसार तयार केली आहे.
        </p>
        <p style={styles.copyright}>
          © २०२५ जिल्हा परिषद नागपूर | ग्रामविकास विभाग
        </p>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    fontFamily:
      "'Noto Sans Devanagari', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: "950px",
    margin: "15px auto",
    padding: "30px",
    background: "#fafafa",
    border: "3px solid #1b5e20",
    borderRadius: "18px",
    boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
    color: "#1a1a1a",
    lineHeight: "1.7",
  },

  govHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #ff9933, #ffffff, #138808)",
    padding: "18px",
    borderRadius: "14px 14px 0 0",
    margin: "-30px -30px 25px -30px",
    color: "blue",
    textAlign: "center",
  },
  emblemImg: {
    width: "65px",
    height: "65px",
    marginRight: "15px",
    borderRadius: "50%",
    border: "2px solid #333",
  },
  govTitle: { flex: 1 },
  govName: { margin: 0, fontSize: "22px", fontWeight: "bold" },
  dept: { margin: 0, fontSize: "15px", fontWeight: 500 },

  mainHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "25px",
    padding: "20px",
    background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
    borderRadius: "14px",
    border: "2px solid #81c784",
  },
  gpLogo: {
    width: "85px",
    height: "85px",
    borderRadius: "50%",
    marginRight: "20px",
    border: "2px solid #2e7d32",
  },
  gpName: {
    margin: "0 0 8px 0",
    fontSize: "30px",
    color: "#1b5e20",
    fontWeight: "bold",
  },
  gpInfo: {
    margin: 0,
    fontSize: "17px",
    color: "#2e7d32",
    fontWeight: "600",
  },

  card: {
    background: "white",
    padding: "25px",
    borderRadius: "14px",
    marginBottom: "25px",
    border: "1px solid #a5d6a7",
    boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
  },
  cardTitle: {
    color: "#1b5e20",
    fontSize: "22px",
    fontWeight: "bold",
    borderBottom: "3px solid #81c784",
    paddingBottom: "10px",
    marginBottom: "18px",
  },

  infoGrid: { display: "grid", gap: "14px" },
  infoRow: {
    display: "flex",
    background: "#f1f8e9",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #c5e1a5",
  },
  infoLabel: {
    background: "#81c784",
    color: "white",
    padding: "12px 16px",
    fontWeight: "bold",
    width: "40%",
  },
  infoValue: {
    padding: "12px 16px",
    background: "#f9fbe7",
    flex: 1,
    color: "#1b5e20",
    fontWeight: "500",
  },
  gramsevakPhoto: {
    width: "120px",
    height: "130px",
    borderRadius: "8px",
    margin: "8px",
    border: "2px solid #81c784",
  },

  link: {
    color: "#2e7d32",
    textDecoration: "none",
    fontWeight: 600,
    padding: "12px 16px",
    display: "block",
  },

  dutyList: {
    paddingLeft: "22px",
    fontSize: "15.5px",
    lineHeight: "1.9",
  },

  footer: { textAlign: "center", paddingTop: "30px" },
  footerLine: {
    height: "2px",
    background: "linear-gradient(to right, transparent, #81c784, transparent)",
    marginBottom: "15px",
  },
  footerText: { fontSize: "15px", color: "#2e7d32" },
  copyright: { fontSize: "13px", color: "#666" },
};

export default GramsevakPage;
